import React from 'react';
import Chip from '@mui/material/Chip';

/**
 * Renders a payment batch (or row) status as a color-coded chip with a
 * human-friendly label. Unknown statuses fall back to the raw value.
 */
const STATUS_META = {
  uploaded: { label: 'Uploaded', color: 'default' },
  import_validating: { label: 'Validating', color: 'info' },
  import_failed: { label: 'Import failed', color: 'error' },
  imported: { label: 'Imported', color: 'info' },
  operations_review: { label: 'In review', color: 'warning' },
  draft: { label: 'Draft', color: 'warning' },
  submitted_to_finance: { label: 'Submitted to Finance', color: 'primary' },
  finance_review: { label: 'Finance review', color: 'primary' },
  returned_to_operations: { label: 'Returned to Ops', color: 'warning' },
  finance_approved: { label: 'Finance approved', color: 'success' },
  finance_rejected: { label: 'Rejected', color: 'error' },
  emails_pending_approval: { label: 'Emails pending', color: 'primary' },
  emails_approved: { label: 'Emails approved', color: 'success' },
  emails_sending: { label: 'Emails sending', color: 'info' },
  emails_sent: { label: 'Emails sent', color: 'success' },
  qbo_export_pending: { label: 'Export pending', color: 'primary' },
  qbo_exported: { label: 'Exported', color: 'success' },
  closed: { label: 'Closed', color: 'default' },
  reopened: { label: 'Reopened', color: 'warning' },
  archived: { label: 'Archived', color: 'default' },
  excluded: { label: 'Excluded', color: 'default' },
  flagged: { label: 'Flagged', color: 'error' },
  needs_operations_review: { label: 'Needs review', color: 'warning' },
};

function BatchStatusChip({ status, size = 'small' }) {
  const meta = STATUS_META[status] || { label: status || '—', color: 'default' };
  return <Chip label={meta.label} color={meta.color} size={size} variant="outlined" />;
}

export default BatchStatusChip;
